import get from 'lodash/get';

const ERROR_PERMISSION_DENIED = 'Permission Required. Allow Location permission and retry';
const ERROR_POSITION_UNAVAILABLE = 'Unable to get current Geolocation';
const ERROR_REQUEST_TIMEOUT = 'The Geolocation request timed out';
const ERROR_UNKNOWN_ERROR = 'Something unexpected happened. We have no clue what it was!';

export default {
  getLocation() {
    return new Promise((resolve, reject) => {
      const onGeoLocationError = error => {
        switch (error.code) {
          case error.PERMISSION_DENIED:
            reject(new Error(ERROR_PERMISSION_DENIED));
            break;

          case error.POSITION_UNAVAILABLE:
            reject(new Error(ERROR_POSITION_UNAVAILABLE));
            break;

          case error.TIMEOUT:
            reject(new Error(ERROR_REQUEST_TIMEOUT));
            break;

          case error.UNKNOWN_ERROR:
            reject(new Error(ERROR_UNKNOWN_ERROR));
            break;
          default:
            reject(new Error(ERROR_UNKNOWN_ERROR));
        }
      };
      const onGeoLocationSuccess = position => {
        const { latitude, longitude, ...rest } = get(position, 'coords');
        resolve({ latitude, longitude, ...rest });
      };

      // Feature detection: Does the browser support geolocation?
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(onGeoLocationSuccess, onGeoLocationError);
      }
      // Apparently, it didn't
      else {
        reject(new Error('Your browser does not appear to support geolocation'));
      }
    });
  },
};
